<div #notesContainer class="notes-container">
  <div
    #notesWrapper
    class="notes-wrapper"
    [ngClass]="{
      'has-scrollbar': notesWrapper?.scrollHeight > notesWrapper?.clientHeight,
    }">
    @if (!isNotesLoaded) {
      <div class="loading-container centered-content">
        <p class="loading">{{ 'detailsNote.loading' | translate }}<span>.</span><span>.</span><span>.</span></p>
      </div>
    } @else {
      @if (notes.length === 0) {
        <div class="notes-empty-container centered-content" data-cy="notes-panel-empty-container">
          <i aria-hidden="true" class="icon-empty-note icon-notes"></i>
          <span>{{ 'detailsNote.emptyNote' | translate }}</span>
        </div>
      } @else {
        @for (note of notes; track note; let i = $index) {
          <iu-note-ui [note]="note" [parent]="this" />
        }
      }
    }
  </div>
  <form class="notes-form" data-cy="notes-panel-form">
    <div class="note-input">
      @if (entryAttachment !== null) {
        <p class="attachment" [title]="entryAttachment?.name">
          <i aria-hidden="true" [ngClass]="[entryAttachment?.name | docIcon]"></i>
          <span>{{ entryAttachment.name }}</span>

          <i
            aria-hidden="true"
            class="attachment-close-button icon-close"
            role="button"
            (click)="deleteEntryAttachment()"></i>
        </p>
      }

      <iu-input-mention-ui
        #inputMentionRef
        [readonly]="!isTagsLoaded || isNoteSending"
        [sendIcon]="true"
        [tags]="tags$"
        (enterEmitter)="sendNote()" />
    </div>

    <div class="notes-buttons">
      @if (entryAttachment === null) {
        <i
          aria-hidden="true"
          class="note-button icon-attach3x"
          data-cy="notes-panel-file-button"
          role="button"
          (click)="displayJoinFilesPanel = true"></i>
      }

      <i
        aria-hidden="true"
        data-cy="notes-panel-follow-button"
        role="button"
        [hideDelay]="250"
        [life]="3000"
        [ngClass]="{
          'note-button': true,
          'icon-bell': !isFollow,
          'icon-bell-slash': isFollow,
        }"
        pTooltip="{{ 'detailsNote.' + (isFollow ? 'un' : '') + 'follow' | translate }}"
        (click)="follow(!isFollow)">
      </i>
    </div>
  </form>

  @if (displayJoinFilesPanel) {
    <iu-modal-ui
      [contentType]="ModalContentType.JOINFILES"
      [hasCloseBtn]="true"
      [title]="'joinFiles.title'"
      (closeModalEmitter)="displayJoinFilesPanel = false">
      <iu-join-file-ui
        [adTable_ID]="table_id"
        [dsKey]="currentDataStoreKey"
        [fromNotes]="true"
        (uploadEnd)="fileUpload($event); displayJoinFilesPanel = false" />
    </iu-modal-ui>
  }
</div>
